import { Box, styled, Switch, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface SwicthButtonProps {
  label: ReactNode
  checked: boolean
  onChange: (v: any) => void
  subtitle?: ReactNode
}

export default function SwitchButton({
  label,
  checked,
  onChange,
  subtitle,
}: SwicthButtonProps) {
  return (
    <StyledBox>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <Typography variant="body1">{label}</Typography>
        <Switch
          checked={checked}
          onChange={(e, checked) => onChange(checked)}
        />
      </Box>
      {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
    </StyledBox>
  )
}

const StyledBox = styled(Box)(({ theme }) => ({
  '& > .MuiBox-root': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
  },
  '& > .MuiTypography-root': {
    marginTop: '0.5rem',
  },
}))
